import { render, staticRenderFns } from "./spaceInfo.vue?vue&type=template&id=fb15409a&scoped=true"
import script from "./spaceInfo.vue?vue&type=script&lang=js"
export * from "./spaceInfo.vue?vue&type=script&lang=js"
import style0 from "./spaceInfo.vue?vue&type=style&index=0&id=fb15409a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb15409a",
  null
  
)

export default component.exports